import React from "react";
import { useLabels } from "../../../hooks/useLabels";

import { labels } from "./labels";
import { PendingUploadsDialog } from "./pending-uploads-dialog";

export const PendingUploadsDialogContainer = ({
	flow = "general",
	open,
	onClose,
}: {
	flow?: "leavePage" | "general";
	open: boolean;
	onClose(hasPendingUploads: false | undefined): void;
}) => {
	const [[titleText, messageText, returnToProductText, continueText], areLabelsLoading] =
		useLabels([
			labels.title,
			labels.message[flow],
			labels.returnToProduct,
			labels.continue[flow],
		]);

	return areLabelsLoading ? null : (
		<PendingUploadsDialog
			messageText={messageText}
			titleText={titleText}
			returnToProductText={returnToProductText}
			continueText={continueText}
			onClose={onClose}
			open={open}
		/>
	);
};
PendingUploadsDialogContainer.displayName = "PendingUploadsDialogContainer";
